import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <section 
        id="hero" 
        className="relative min-h-screen bg-cover bg-center"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/ea3bba43a5d95f491f17f4f7543903eb/117ddd9a04baf61fc04bd2c439758c04.png')`
        }}
      >
        <div className="w-full h-screen relative">
          {/* キャッチコピー - 左端固定 */}
          <div className="absolute left-4 md:left-8 top-[20%] md:top-1/2 transform md:-translate-y-1/2 max-w-[85%] md:max-w-none">
            <h1 className="text-2xl md:text-5xl lg:text-6xl font-bold text-[#333333] leading-relaxed animate-gentle-fade-up">
              人生を、<br />
              もっと自由に。
            </h1>
          </div>

          {/* バッジとCTA - デスクトップのみ右下隅に表示 */}
          <div className="hidden md:block absolute bottom-8 right-8">
            {/* バッジ - デスクトップは横並び */}
            <div className="flex flex-row gap-3 mb-6 items-end justify-end">
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-4 pt-10 pb-3 shadow-sm flex flex-col items-center justify-end min-h-[80px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-24-hours-line text-slate-100 text-2xl"></i>
                </div>
                <div className="text-sm font-semibold text-slate-100 mb-1 tracking-wide relative z-10 text-center leading-tight">24時間オーダーメイド</div>
                <div className="text-xs text-slate-400 text-center leading-tight relative z-10">あなたに合わせた支援</div>
              </div>
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-4 pt-10 pb-3 shadow-sm flex flex-col items-center justify-end min-h-[80px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-shield-check-line text-slate-100 text-2xl"></i>
                </div>
                <div className="text-sm font-semibold text-slate-100 mb-1 tracking-wide relative z-10 text-center leading-tight">有資格者対応</div>
                <div className="text-xs text-slate-400 text-center leading-tight relative z-10">介護福祉士・健康運動指導士・看護師</div>
              </div>
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-4 pt-10 pb-3 shadow-sm flex flex-col items-center justify-end min-h-[80px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-car-line text-slate-100 text-2xl"></i>
                </div>
                <div className="text-sm font-semibold text-slate-100 mb-1 tracking-wide relative z-10 text-center leading-tight">福祉タクシー経営許可</div>
                <div className="text-xs text-slate-400 text-center leading-tight relative z-10">運輸局認可取得</div>
              </div>
            </div>

            {/* CTAボタン - デスクトップは横並び */}
            <div className="flex flex-row gap-4 justify-end">
              <Button 
                variant="primary" 
                size="lg" 
                href="tel:+817090045641"
                className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-base py-3 px-8"
              >
                <i className="ri-phone-line mr-2 text-base"></i>
                070-9004-5641
              </Button>
              <Button 
                variant="line" 
                size="lg" 
                href="https://line.me/R/ti/p/@251xqjgz?_gl=1*8soeuu*_gcl_au*MTUyNTMzMzgwOC4xNzU5NzQyMTgz*_ga*NjgyMTMyNjIuMTc1OTc0MjE4NA..*_ga_0PV16Y9CZG*czE3NjQ3NTgwMzUkbzIkZzAkdDE3NjQ3NTgwNDEkajU0JGwwJGgw"
                className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-base py-3 px-8"
              >
                <i className="ri-message-line mr-2 text-base"></i>
                LINEで相談
              </Button>
              <Button 
                variant="tel" 
                size="lg" 
                onClick={() => scrollToContact()}
                className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-base py-3 px-8"
              >
                <i className="ri-calendar-line mr-2 text-base"></i>
                お問い合わせ
              </Button>
            </div>
          </div>

          {/* モバイル用バッジ - ヒーローセクション内の下部に表示 */}
          <div className="md:hidden absolute bottom-3 left-3 right-3 max-w-[94%] mx-auto pb-1">
            <div className="flex flex-row gap-1 overflow-x-auto scrollbar-hide pt-5">
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-2 pt-6 pb-1.5 shadow-sm flex flex-col items-center justify-end min-h-[50px] min-w-[110px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80 flex-shrink-0">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-24-hours-line text-slate-100 text-base"></i>
                </div>
                <div className="text-[9px] font-semibold text-slate-100 mb-0.5 tracking-wide relative z-10 text-center leading-tight whitespace-nowrap">24時間オーダーメイド</div>
                <div className="text-[7px] text-slate-400 text-center leading-tight relative z-10 whitespace-nowrap">あなたに合わせた支援</div>
              </div>
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-2 pt-6 pb-1.5 shadow-sm flex flex-col items-center justify-end min-h-[50px] min-w-[110px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80 flex-shrink-0">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-shield-check-line text-slate-100 text-base"></i>
                </div>
                <div className="text-[9px] font-semibold text-slate-100 mb-0.5 tracking-wide relative z-10 text-center leading-tight whitespace-nowrap">有資格者対応</div>
                <div className="text-[7px] text-slate-400 text-center leading-tight relative z-10 whitespace-nowrap">介護福祉士・健康運動指導士・看護師</div>
              </div>
              <div className="bg-slate-800/80 backdrop-blur-md rounded-md px-2 pt-6 pb-1.5 shadow-sm flex flex-col items-center justify-end min-h-[50px] min-w-[110px] border border-slate-700/30 hover:shadow-md transition-all duration-300 hover:scale-102 hover:-translate-y-1 relative overflow-visible bg-gradient-to-br from-slate-800/80 to-slate-900/80 flex-shrink-0">
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none rounded-md"></div>
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-8 h-8 flex items-center justify-center bg-slate-700/90 rounded-full shadow-lg border-2 border-slate-600/50">
                  <i className="ri-car-line text-slate-100 text-base"></i>
                </div>
                <div className="text-[9px] font-semibold text-slate-100 mb-0.5 tracking-wide relative z-10 text-center leading-tight whitespace-nowrap">福祉タクシー経営許可</div>
                <div className="text-[7px] text-slate-400 text-center leading-tight relative z-10 whitespace-nowrap">運輸局認可取得</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* モバイル用CTAボタン - ヒーローセクションの外に配置 */}
      <div className="md:hidden bg-white py-4 px-3">
        <div className="flex flex-col gap-2 max-w-md mx-auto">
          <Button 
            variant="primary" 
            size="lg" 
            href="tel:+817090045641"
            className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm py-3 px-4 w-full"
          >
            <i className="ri-phone-line mr-2 text-base"></i>
            070-9004-5641
          </Button>
          <Button 
            variant="line" 
            size="lg" 
            href="https://line.me/R/ti/p/@251xqjgz?_gl=1*8soeuu*_gcl_au*MTUyNTMzMzgwOC4xNzU5NzQyMTgz*_ga*NjgyMTMyNjIuMTc1OTc0MjE4NA..*_ga_0PV16Y9CZG*czE3NjQ3NTgwMzUkbzIkZzAkdDE3NjQ3NTgwNDEkajU0JGwwJGgw"
            className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm py-3 px-4 w-full"
          >
            <i className="ri-message-line mr-2 text-base"></i>
            LINEで相談
          </Button>
          <Button 
            variant="tel" 
            size="lg" 
            onClick={() => scrollToContact()}
            className="shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm py-3 px-4 w-full"
          >
            <i className="ri-calendar-line mr-2 text-base"></i>
            お問い合わせ
          </Button>
        </div>
      </div>

      <style>{`
        @keyframes gentleFadeUp {
          0% {
            opacity: 0;
            transform: translateY(30px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-gentle-fade-up {
          animation: gentleFadeUp 1.8s ease-out forwards;
          will-change: transform, opacity;
          transform: translateZ(0);
          backface-visibility: hidden;
          perspective: 1000px;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </>
  );
}
